// extracted by mini-css-extract-plugin
export default {"Checkbox":"Checkbox_Checkbox__X8oXU","Checkmark":"Checkbox_Checkmark__1fP+F","CheckboxInput":"Checkbox_CheckboxInput__UeaOm"};